<div class="main-page-wrapper">
  <div class="policy-list-container">

    <div class="page-header">
      <div class="header-title-section">
        <mat-icon>security</mat-icon>
        <h1>Poliçe Listesi</h1>
      </div>

      <div class="header-details-row">
        <div class="detail-item">
          <mat-icon>person</mat-icon>
          <span><strong>Kullanıcı:</strong> {{ currentUser || 'Bilinmiyor' }}</span>
        </div>

        <div class="detail-item">
          <mat-icon>phone</mat-icon>
          <span><strong>Telefon:</strong> {{ formatPhone(customerPhone) }}</span>
        </div>

        <div class="detail-item">
          <mat-icon>format_list_numbered</mat-icon>
          <span><strong>Toplam:</strong> {{ dataSource.data.length }} Poliçe</span>
        </div>

        <div class="detail-item">
          <mat-icon [style.color]="isTokenValid ? '#4caf50' : '#f44336'">verified</mat-icon>
          <span>{{ isTokenValid ? 'Token Doğrulandı' : 'Geçersiz Token' }}</span>
        </div>
      </div>
    </div>

    <div class="content-card">
      <div class="filter-container">
        <mat-form-field appearance="outline">
          <mat-label>Telefon Numarası ile Ara</mat-label>
          <input matInput #phoneInput type="tel" placeholder="(555) 123 45 67"
            (input)="phoneInput.value = formatPhoneNumber(phoneInput.value)" (keyup.enter)="onSearch(phoneInput.value)">
          <mat-icon matSuffix (click)="onSearch(phoneInput.value)" style="cursor: pointer;">search</mat-icon>
        </mat-form-field>
      </div>

      <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort>

          <ng-container matColumnDef="saleChannel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Kanal </th>
            <td mat-cell *matCellDef="let policy"> {{policy.saleChannel}} </td>
          </ng-container>

          <ng-container matColumnDef="orderNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sipariş No </th>
            <td mat-cell *matCellDef="let policy"> {{policy.orderNumber}} </td>
          </ng-container>

          <ng-container matColumnDef="policyNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Poliçe No </th>
            <td mat-cell *matCellDef="let policy"> {{policy.policyNumber}} </td>
          </ng-container>

          <ng-container matColumnDef="packageId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Paket No </th>
            <td mat-cell *matCellDef="let policy"> {{policy.packageId}} </td>
          </ng-container>

          <ng-container matColumnDef="orderDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tarih </th>
            <td mat-cell *matCellDef="let policy"> {{formatDate(policy.orderDate)}} </td>
          </ng-container>

          <ng-container matColumnDef="policyStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Durum </th>
            <td mat-cell *matCellDef="let policy"> {{policy.policyStatus}} </td>
          </ng-container>

          <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Ad - Soyad</th>
            <td mat-cell *matCellDef="let policy"> {{policy.customerName}} </td>
          </ng-container>

          <ng-container matColumnDef="customerPhone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Telefon </th>
            <td mat-cell *matCellDef="let policy"> {{formatPhone(policy.customerPhone)}} </td>
          </ng-container>

          <ng-container matColumnDef="customerIdentity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> TC No </th>
            <td mat-cell *matCellDef="let policy"> {{maskIdentity(policy.customerIdentity)}} </td>
          </ng-container>

          <ng-container matColumnDef="productName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Ürün Adı </th>
            <td mat-cell *matCellDef="let policy"> {{policy.productName}} </td>
          </ng-container>

          <ng-container matColumnDef="deviceSerial">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> IMEI </th>
            <td mat-cell *matCellDef="let policy"> {{policy.deviceSerial}} </td>
          </ng-container>

          <ng-container matColumnDef="deviceBrand">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Marka </th>
            <td mat-cell *matCellDef="let policy"> {{policy.deviceBrand}} </td>
          </ng-container>

          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sigorta Şirketi </th>
            <td mat-cell *matCellDef="let policy"> {{policy.company}} </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> İşlemler </th>
            <td mat-cell *matCellDef="let policy">
              <button mat-icon-button (click)="showPolicyDetails(policy)" matTooltip="Düzenle">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="downloadPolicy(policy)" matTooltip="İndir" [disabled]="isDownloading || policy.company?.toUpperCase().includes('HDI')">
                <mat-icon>download</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 25, 50]"></mat-paginator>
      </div>
    </div>
  </div>
</div>